import { Button, Link, List, ListItem, Stack, useTheme } from '@mui/material';
import { Icons, HXCIcon } from '../../HXCIcon';
import type { MenuLinkData } from '../LocalLinks/LocalLinks';
import { Text } from '../../Text';

interface SubMenuContentProps {
  menuLink: MenuLinkData;
  onBackClick: () => void;
}

const SubMenuContent = ({ menuLink, onBackClick }: SubMenuContentProps) => {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        width: '300px',
        height: '100%',
        backgroundColor: theme.palette.black.main,
      }}
    >
      <Stack
        direction={'row'}
        justifyContent={'initial'}
        sx={{ padding: '8px 16px' }}
        alignItems={'center'}
      >
        <Button onClick={onBackClick} color="white" variant="text" sx={{ minWidth: 0, padding: 0 }}>
          <HXCIcon name={Icons.ArrowLeftRg} color={'white'} />
        </Button>
        <Text
          variant="p"
          color={'white'}
          sx={{ fontSize: '18px', paddingLeft: '8px', fontWeight: 'bold' }}
        >
          {menuLink.text}
        </Text>
      </Stack>
      <List>
        {menuLink.options.map((option) => (
          <ListItem key={option.href}>
            <Link href={option.href} underline="none">
              <Text variant="p" color="white">
                {option.text}
              </Text>
            </Link>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
};

export default SubMenuContent;
